// extracted by mini-css-extract-plugin
export default {"container":"S03_container__O2AuR","wrapper":"S03_wrapper__o8uUT","left":"S03_left__NAsEq","button":"S03_button__Vrif5","right":"S03_right__YGR99","active":"S03_active__GD1uk"};